import React from 'react';

const TermsAndConditionsFrCA: React.FC = () => {
    return (
        <div style={{ padding: '32px 32px' }}>
            <p
                style={{ borderBottom: '1px solid black' }}
                className='pageTitle'
            >
                <h4>Modalités et Conditions:</h4>
            </p>
            <p>
                Veuillez lire attentivement les modalités et les passer en revue
                avec le demandeur avant de soumettre la demande à Volkswagen
                Finance.
            </p>
            <ol>
                <li>
                    Volkswagen Finance peut, en tout temps et sans préavis,
                    modifier ou réviser ces modalités et conditions.
                </li>
                <li>
                    Les services financiers décrits sur le présent site sont
                    offerts seulement au Canada et peuvent ne pas être
                    disponibles dans toutes les provinces.
                </li>
                <li>
                    L&#39;admissibilité à ces services financiers, sauf dans la
                    mesure prévue par la loi, est déterminée seulement par
                    Volkswagen Finance.
                </li>
                <li>
                    Les calculs, les montants, les nombres et les renseignements
                    fournis sur ce site sont des estimations et sont donnés à
                    titre d&#39;exemple. Ils ne constituent pas une offre et
                    sont sujets à changement sans préavis.
                </li>
                <li>
                    Volkswagen Finance ne garantie pas l&#39;exactitude de
                    l&#39;information présentée sur le site. En visitant ce
                    site, vous convenez que Volkswagen Finance n&#39;assume
                    aucune responsabilité (découlant d&#39;un contrat, d&#39;un
                    délit ou autre) à l&#39;égard de dommages directs,
                    indirects, accessoires, consécutifs ou particuliers
                    résultant de l&#39;utilisation de ce site.
                </li>
                <li>
                    Les renseignements que vous fournissez à Volkswagen Finance
                    peuvent ne pas être tenus sous le sceau de la
                    confidentialité. Toutefois, Volkswagen Finance utilisera ces
                    renseignements de manière légale et à des fins légales.
                </li>
                <li>La présente demande est soumise en votre nom.</li>
            </ol>
            <p>
                <strong>RECONNAISSANCE ET CONSENTEMENT</strong>
            </p>
            <p>
                Crédit VW Canada, Inc. f.a.s.r.s Volkswagen Finance («
                Volkswagen Finance ») recueille des renseignements (définis ci-
                dessous) afin de déterminer si nous concluons ou non un contrat
                de location ou de vente conditionnelle d’un véhicule automobile
                (le « contrat », s’il y a lieu) avec vous et, si nous acceptons
                votre demande, afin de remplir et d’administrer ce contrat, ce
                qui nécessite de recueillir, stocker, utiliser, tenir à jour et
                communiquer les renseignements conformément à la politique de
                confidentialité de VW (défini ci-dessous) appropriée.
            </p>
            <p>
                Les « renseignements » désignent tous les renseignements
                personnels pertinents que nous recueillons sur vous, y compris
                des renseignements sur le crédit, l’emploi, l’assurance du
                véhicule, la situation financière, votre dossier médical si vous
                avez eu un accident, ainsi que tout autre renseignement que nous
                obtenons sur vous durant le cours de votre contrat avec nous. À
                compter de la date de la présente demande de crédit et jusqu’à
                ce que vous ayez acquittés toutes vos obligations aux termes du
                contrat, vous consentez à ce que Volkswagen Finance et Groupe
                Volkswagen Canada (« VGCA » ci-après collectivement « VW »)
                peuvent utiliser vos renseignements afin de vérifier votre
                identité (notamment, votre nom, date de naissance et
                coordonnées) et à des fins d’évaluation initiale et continue du
                crédit, y compris en obtenant périodiquement des rapports de
                solvabilité et des renseignements sur votre historique financier
                et de crédit de toute agence d’évaluation du crédit, incluant
                notamment celles mentionnées ci-dessous. Nous pourrons utiliser
                ces renseignements afin de créer des évaluations/pointage de
                crédit personnalisés de votre solvabilité, même si votre demande
                de crédit est refusée ou approuvée mais que vous ne concluez pas
                de contrat avec nous. Nous pourrons utiliser ce pointage de
                crédit personnalisé afin de déterminer si nous conclurons un
                contrat avec vous et vous accorderons du crédit. Si nous
                concluons un contrat avec vous, VW peut également utiliser ces
                renseignements afin d’effectuer des suivis de l’assurance du
                véhicule, d’administration interne, de publication du contrat et
                droits de Volkswagen Finance et d’immatriculation du véhicule,
                d’administration de fin de location et de vente auprès de vous
                si vous décidez d’acheter le véhicule que vous louez, de
                garanties du véhicule, de service à la clientèle et de rappels,
                de recouvrement et pour tout autre motif exigé ou autorisé par
                la loi. Avec votre consentement, VW peut également utiliser ces
                renseignements pendant et après la durée du contrat à des fins
                de marketing.
            </p>
            <p>Vos renseignements:</p>
            <ul>
                <li>
                    peuvent être stockés au bureau de Volkswagen Finance au
                    500-1340 Pickering Pky, Pickering, ON, L1V 0C4, au bureau du
                    concessionnaire VGCA autorisé mentionné ci- dessus, sur des
                    serveurs situés à l’extérieur du Canada (y compris aux
                    États-Unis et en Allemagne) si vous consentez au partage de
                    vos renseignements, au bureau de VGCA situé au 777 Bayly St.
                    West, Ajax, ON, à l’extérieur du Canada à des fins de
                    traitement, et peuvent être assujettis aux lois de ces
                    territoires étrangers et consultés par les autorités
                    responsables de l’application de la loi ou les tribunaux
                    locaux;
                </li>
                <li>
                    {' '}
                    sont accessibles uniquement aux employés, aux sociétés
                    affiliées et aux représentants autorisés de VW et du
                    concessionnaire VGCA mentionné ci-dessus, dont la
                    description de poste, les tâches, les fonctions et le mandat
                    nécessitent et justifient l’accès à vos renseignements et à
                    leur utilisation;
                </li>
                <li>
                    {' '}
                    peuvent être communiqués, transférés, stockés ou traités par
                    des fournisseurs de services tiers, des entreprises de
                    traitement des paiements, des prêteurs, des agences
                    d’évaluation du crédit, Equifax Canada Co. (Box 190, Jean
                    Talon Station, Montréal, Québec, H1S 2Z2) et Trans Union of
                    Canada Inc. (Relation avec les consommateurs, P.O. Box 338,
                    LCD1, Hamilton, Ontario, L8L 7W2), (cela inclus de
                    communiquer un rapport négatif si vous ne respectez pas vos
                    obligations, ce qui pourrait avoir un effet néfaste sur
                    votre crédit) avec lesquelles agences vous pourrez
                    communiquer et obtenir votre rapport de crédit et le
                    rectifier, le cas échéant, ou d’autres entités affiliées à
                    VW dans d’autres pays; et
                </li>
                <li>
                    {' '}
                    peuvent être communiqués à des fins de financement aux
                    prêteurs de VW, à une entité qui se porte acquéreuse de VW
                    en totalité ou en partie, ou à la ou aux entités qui
                    découlent d’une restructuration d’entreprise de VW.
                </li>
            </ul>
            <p>
                VW et ses fournisseurs de services maintiennent des normes
                élevées en matière de mesures de protection physiques,
                électroniques et procédurales en vue de protéger vos
                renseignements et conserveront ceux-ci aussi longtemps que la
                loi l’exigera ou l’autorisera.
            </p>
            <p>
                Vous avez le droit, en tout temps, d’accéder à vos
                renseignements ou de les corriger. Il est possible de nous
                joindre aux adresses indiquées ci-dessous.
            </p>
            <p>
                Pour obtenir de plus amples renseignements, veuillez-vous
                reporter à notre politique de confidentialité de Volkswagen
                Finance{' '}
                <a href='https://www.vw.ca/fr/tools/navigation/footer/links/privacy-policy.html'>
                    ici
                </a>{' '}
                et à l’adresse suivante:{' '}
                <a href='https://finance.vwmodels.ca/index-fr.php'>
                    {' '}
                    www.vwfinance.ca
                </a>
            </p>
            <p>
                Vous pouvez également trouver la politique de confidentialité
                pour VGCA{' '}
                <a href='https://www.vw.ca/fr/tools/navigation/footer/links/privacy-policy.html'>
                    ici
                </a>{' '}
                et à l’adresse suivante :{' '}
                <a href='https://www.vw.ca/fr.html?_ga=2.105989315.1587037015.1566593242-705666413.1553616766'>
                    www.vw.ca
                </a>
            </p>
            <p>
                <strong>
                    <u>EN APPOSANT VOTRE SIGNATURE CI-DESSOUS, VOUS:</u>
                </strong>
            </p>
            <ol style={{ listStyleType: 'lower-roman' }}>
                <li>
                    <strong>
                        <u>
                            CONSENTEZ À CE QUE NOUS OBTENIONS UN RAPPORT DE
                            SOLVABILITÉ VOUS VISANT MAINTENANT ET À DES FINS
                            D’ÉVALUATIONS CONTINUES DU CRÉDIT, JUSQU’À CE QUE LE
                            CONTRAT SOIT PAYÉ EN TOTALITÉ ET EXÉCUTÉ DANS SON
                            INTÉGRALITÉ, ET À CE QUE NOUS PUISSIONS TRANSMETTRE
                            PÉRIODIQUEMENT VOS RENSEIGNEMENTS À DES AGENCES
                            D’ÉVALUATION DU CRÉDIT
                        </u>
                    </strong>
                    <strong>; </strong>
                </li>
                <li>
                    <strong>
                        {' '}
                        consentez à ce que le concessionnaire VGCA mentionné
                        ci-dessus partage vos renseignements avec Volkswagen
                        Finance aux fins de l’évaluation de votre demande de
                        crédit;
                    </strong>
                </li>
                <li>
                    <strong>
                        consentez à ce que Volkswagen Finance continue
                        d’administrer tous les contrats que vous signez dans le
                        cadre de cette demande de crédit et à ce que Volkswagen
                        Finance partage vos renseignements raisonnablement
                        nécessaires pour administrer ces contrats;{' '}
                    </strong>
                </li>
                <li>
                    <strong>
                        déclarez et garantissez qu’aucune procédure ou
                        proposition de faillite n’existe à votre égard, et que
                        vos renseignements sont véridiques et exacts.
                    </strong>
                </li>
            </ol>
            <p>
                De plus, Volkswagen Finance et VGCA souhaitent obtenir votre
                consentement pour les motifs indiqués sous les points 1 et 2 de
                la colonne « Motif » ci-dessous.{' '}
            </p>
            <p>Vous pouvez vous désabonner à tout moment: </p>
            <ul>
                <li> en composant le 1 800 668-8224 ou</li>
                <li>
                    {' '}
                    en écrivant à l’adresse suivante: 500-1340 Pickering Pky,
                    Pickering, Ontario, L1V 0C4
                </li>
                Aux soins de : Agent de la protection de la vie privée
            </ul>
            <table style={{ width: '720px' }}>
                <tbody>
                    <tr>
                        <td style={{ width: '343px' }} colSpan={2}>
                            <p style={{ textAlign: 'center' }}>
                                <strong>CONSENTEMENT</strong>
                            </p>
                        </td>
                        <td style={{ width: '363px' }}>
                            <p style={{ textAlign: 'center' }}>
                                <strong>MOTIF</strong>
                            </p>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: '147.75px' }}>
                            <p style={{ textAlign: 'center' }}>
                                <strong>Demandeur</strong>
                            </p>
                        </td>
                        <td style={{ width: '195.25px' }}>
                            <p style={{ textAlign: 'center' }}>
                                <strong>Codemandeur/garant</strong>
                            </p>
                        </td>
                        <td style={{ width: '363px' }} rowSpan={2}>
                            <p>
                                1. À ce que Volkswagen Finance ou VGCA utilise
                                mes renseignements personnels pour m’envoyer du
                                contenu de marketing concernant de nouveaux
                                véhicules, de produits ou service, d’événements
                                et d’offres promotionnelles ou de fidélisation,
                                y compris des offres de financement ou de
                                location (« documents de marketing »).
                            </p>
                            <p>&nbsp;</p>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: '147.75px' }}>
                            <p>
                                <input type='checkbox' /> Je consens
                                <br />
                                <input type='checkbox' /> Je ne consens pas
                            </p>
                            <p>&nbsp;</p>
                        </td>
                        <td style={{ width: '195.25px' }}>
                            <p>
                                <input type='checkbox' /> Je consens
                                <br />
                                <input type='checkbox' /> Je ne consens pas
                            </p>
                            <p>&nbsp;</p>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: '147.75px' }}>
                            <p>
                                <input type='checkbox' /> Je consens
                                <br />
                                <input type='checkbox' /> Je ne consens pas
                            </p>
                            <p>
                                <strong>&nbsp;</strong>
                            </p>
                        </td>
                        <td style={{ width: '195.25px' }}>
                            <p>
                                <input type='checkbox' /> Je consens
                                <br />
                                <input type='checkbox' /> Je ne consens pas
                            </p>
                            <p>
                                <strong>&nbsp;</strong>
                            </p>
                        </td>
                        <td style={{ width: '363px' }}>
                            <p>
                                2.&nbsp; À recevoir des communications
                                concernant le contrat et, si vous consentez à
                                l’énoncé ci-dessus, des documents de marketing
                                en format électronique (p. ex., par courriel ou
                                par message texte ).
                            </p>
                            <p>&nbsp;</p>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p>
                <strong>
                    Je conviens que j’ai eu la possibilité de lire ce document
                    Déclaration et consentement avant de le signer et que j’en
                    ai reçu une copie.{' '}
                </strong>
            </p>
            <p>&nbsp;</p>
            <table>
                <tbody>
                    <tr>
                        <td style={{ width: '482px' }}>
                            <p>Signature du demandeur</p>
                            <p>&nbsp;</p>
                        </td>
                        <td style={{ width: '132px' }}>
                            <p>Date:</p>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: '482px' }}>
                            <p>Signature du codemandeur/garant</p>
                            <p>&nbsp;</p>
                        </td>
                        <td style={{ width: '132px' }}>
                            <p>Date:</p>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default TermsAndConditionsFrCA;
